import _ from 'lodash';
import { FilterConf } from './Filter.conf';
import { SearchConf } from './Search.conf';
export const QueryConf = {
  get: (list, filter, search, view, calendar) => {
    const { pagination, sort } = list;
    const { value: searchValue } = search;
    const { value: viewValue } = view.value;
    const { value: filterValue } = filter;
    const { sort: sortCalendar } = calendar;

    return {
      pagination:
        viewValue === 'list' ? { ...pagination } : { page: 1, pageSize: 10000 },
      sort:
        viewValue === 'list'
          ? [`${sort.by}:${sort.direction}`]
          : [`${sortCalendar.by}:${sortCalendar.direction}`],
      filters: {
        $or: SearchConf.query.keys.map(({ key, operator }) =>
          _.setWith(
            {},
            _.chunk([...key.split('.'), operator]),
            searchValue,
            Object
          )
        ),
        $and: FilterConf.query.keys.map(({ key, operator, value }) => {
          const newValue = _.get(filterValue, _.head(_.split(value, '.')));
          if (_.isArray(newValue)) {
            return {
              $or: newValue.map((item) => {
                return item?.id === null
                  ? _.setWith(
                    {},
                    _.chunk([...key.split('.'), '$null']),
                    true,
                    Object
                  )
                  : _.setWith(
                    {},
                    _.chunk([...key.split('.'), operator]),
                    _.get(item, _.last(_.split(value, '.'))),
                    Object
                  );
              }),
            };
          } else {
            return newValue?.id === null
              ? { [key]: { $null: true } }
              : _.setWith(
                {},
                _.chunk([...key.split('.'), operator]),
                _.get(filterValue, value),
                Object
              );
          }
        }),
      },
    };
  },
};
